import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import AdminLayout from "../../layout/AdminLayoutSewa";
import Swal from "sweetalert2";
import { adminListZoneCustomers } from "../../api";

const Zone = () => {
  const { zoneId } = useParams();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const load = async () => {
    try {
      setLoading(true);
      const res = await adminListZoneCustomers(zoneId, "perumahan", search);
      setRows(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error(error);
      await Swal.fire({
        icon: "error",
        title: "Gagal",
        text: error?.response?.data?.error || "Gagal load data penghuni.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [zoneId]);

  const filtered = useMemo(() => {
    const q = String(search || "").trim().toLowerCase();
    if (!q) return rows;

    return rows.filter((r) =>
      [
        r.bil,
        r.no_akaun,
        r.nombor_unit,
        r.kawasan,
        r.nama_penyewa,
        r.telefon,
      ]
        .filter(Boolean)
        .some((x) => String(x).toLowerCase().includes(q))
    );
  }, [rows, search]);

  return (
    <AdminLayout>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Data Penghuni</h2>
            <p className="text-sm text-gray-500 mt-1">
              Kawasan / Zone: <span className="font-semibold">{zoneId}</span>
            </p>
          </div>

          <button
            onClick={load}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
          >
            {loading ? "Loading..." : "Refresh"}
          </button>
        </div>

        <div className="mt-4">
          <label className="text-xs text-gray-600">Search</label>
          <input
            className="border rounded-md w-full p-2 text-sm"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="No akaun / bil / unit / nama / telefon"
          />
        </div>

        <div className="mt-5 overflow-x-auto">
          <table className="w-full text-sm border">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2 border">Bil</th>
                <th className="text-left p-2 border">No Akaun</th>
                <th className="text-left p-2 border">Unit</th>
                <th className="text-left p-2 border">Nama Penyewa</th>
                <th className="text-left p-2 border">Telefon</th>
                <th className="text-left p-2 border">Kawasan</th>
                <th className="text-left p-2 border">Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" className="p-3 text-center text-gray-500">
                    Loading...
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan="7" className="p-3 text-center text-gray-500">
                    Tiada data.
                  </td>
                </tr>
              ) : (
                filtered.map((r) => (
                  <tr key={r.id} className="border-t hover:bg-gray-50">
                    <td className="p-2 border">{r.bil || "-"}</td>
                    <td className="p-2 border font-semibold">{r.no_akaun || "-"}</td>
                    <td className="p-2 border">{r.nombor_unit || "-"}</td>
                    <td className="p-2 border">{r.nama_penyewa || "-"}</td>
                    <td className="p-2 border">{r.telefon || "-"}</td>
                    <td className="p-2 border">{r.kawasan || "-"}</td>
                    <td className="p-2 border">{r.status || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Zone;